import type { Player } from './types';

const fields = [
  'last_market_value',
  'last_portfolio_return',
  'last_pnl_sum',
  'last_fx_return',
  'valuation_at',
] as const;

// Preserve server microseconds: Date.parse alone loses ordering within a ms.
const valuationTime = (value?: string | null) => {
  if (!value) return undefined;
  const milliseconds = Date.parse(value);
  if (!Number.isFinite(milliseconds)) return undefined;
  const fraction = /\.(\d+)/.exec(value)?.[1] ?? '';
  return (
    Math.floor(milliseconds / 1000) * 1_000_000 +
    Number(fraction.slice(0, 6).padEnd(6, '0'))
  );
};

/** Keep newer real-time summary fields while still merging histories/details. */
export const mergeValuation = <T extends Partial<Player>>(
  current: Partial<Player> | undefined,
  incoming: T,
): T => {
  const previous = valuationTime(current?.valuation_at);
  const next = valuationTime(incoming.valuation_at);
  if (previous === undefined || (next !== undefined && next >= previous)) {
    return incoming;
  }
  // Untimestamped legacy events must not replace an established RT summary.
  const result = { ...incoming };
  fields.forEach(field => {
    if (current && field in current) {
      Object.assign(result, { [field]: current[field] });
    }
  });
  return result;
};
